import { DataBean } from "../DataBean";

export class RequestApprovalBpm extends DataBean {


    public async getRequestApprovalBpmCatalogRender(page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getRequestApprovalBpmCatalogRender_Number_Number_java.util.Map",
            [page, rows, props]
        );
    }

    public async singRequestProcessBpm(idRequestApprovalBpm: number, state: number, observation, idEmployee: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.RequestApprovalBpm_singRequestProcessBpm_Number_Number_String_Number",
            [idRequestApprovalBpm, state, observation, idEmployee]
        );
    }

    public async singListRequestProcessBpm(ids: number, state: number, observation: string, idEmployee: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_singListRequestProcessBpm_java.util.List_Number_String_Number",
            [ids, state, observation, idEmployee]
        );
    }
    
    public async getRequestApprovalSingRender(idApprovalDocuement: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getRequestApprovalSingRender_Number",
            [idApprovalDocuement]
        );
    }

    public async cancelApprovalDocument(idApprovalDocument: number): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.Map_cancelApprovalDocument_Number",
            [idApprovalDocument]
        );
    }



}